/*
 * @Author: your name
 * @Date: 2022-01-29 12:05:43
 * @LastEditTime: 2022-01-29 16:10:27
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /es-package/packages/es-mpx-shared/lib/eError.js
 */
import { isString, isObject } from './type'
export class EwebError extends Error {
  constructor(option) {
    super()
    if (isString(option)) {
      this.message = option
    } else if (isObject(option)) {
      Object.assign(this, option)
    }
  }
}